const { trackGtm, trackGtm4 } = require('../../../../js/functions');

const CLASS_TITLE = '.carousel-highlight--title';
const CLASS_LINKS = '.small-image-above-title a';
const CLASS_NAV_PREVIOUS = '.carousel-highlight-nav--previous';
const CLASS_NAV_NEXT = '.carousel-highlight-nav--next';
const CLASS_NAV_BULLET = '.carousel-highlight-nav--dot';

module.exports = {
	init() {
		const smalImageAboveTitleList = this.root.querySelectorAll(CLASS_LINKS);
		const title = this.root.querySelector(CLASS_TITLE);
		const carouselNavPrevious = this.root.querySelector(CLASS_NAV_PREVIOUS);
		const carouselNavNext = this.root.querySelector(CLASS_NAV_NEXT);
		const carouselBullets = this.root.querySelectorAll(CLASS_NAV_BULLET);

		smalImageAboveTitleList.forEach(element => {
			element.addEventListener('click', () => {
				trackGtm({
					eventCategory: 'cta',
					eventAction: 'read',
					eventLabel: element.href,
				});
			});
		});

		carouselNavPrevious.addEventListener('click', () => {
			this.trackingControllArrowsGa4(title, carouselNavPrevious, 'previous');
		});

		carouselNavNext.addEventListener('click', () => {
			this.trackingControllArrowsGa4(title, carouselNavNext, 'next');
		});

		carouselBullets.forEach(bullet => {
			bullet.addEventListener('click', () => {
				trackGtm4({
					event: 'GA4_event_c_content_navigation_click',
					widget_name: 'V3-Article-carousel',
					widget_title: title ? title.innerHTML.trim() : 'No title',
					widget_type: 'article',
					link_text: bullet ? bullet.innerHTML.trim() : 'No text',
					link_url: 'No url',
					interaction_type: `bullet ${
						bullet ? bullet.innerHTML.slice(-1).trim() : 'No text'
					}`,
				});
			});
		});
	},
	trackingControllArrowsGa4(title, link, interactionType) {
		trackGtm4({
			event: 'GA4_event_c_content_navigation_click',
			widget_name: 'V3-Article-carousel',
			widget_title: title ? title.innerHTML.trim() : 'No title',
			widget_type: 'article',
			link_text: link ? link.innerHTML.trim() : 'No text',
			link_url: 'No url',
			interaction_type: interactionType,
		});
	},
};
